import { handleActions } from 'redux-actions';
import { mergeLeft } from 'ramda';

import {
  patientEngagementSetStatusesWithPatientId,
  requestGetPatientStatusesById,
  patientEngagementSortTable,
} from 'store/actionCreators/patientEngagement';

const defaultState = {
  sortBy: 'statusSort',
  order: 'asc',
  loading: false,
  statuses: null,
  currentPatient: null,
};

export default handleActions(
  {
    [requestGetPatientStatusesById]: state =>
      mergeLeft(
        {
          sortBy: 'statusSort',
          order: 'asc',
          loading: true,
          statuses: null,
          currentPatient: null,
        },
        state,
      ),
    [patientEngagementSetStatusesWithPatientId]: (
      state,
      { payload: { statuses, currentPatient } },
    ) =>
      mergeLeft(
        {
          loading: false,
          statuses,
          currentPatient,
        },
        state,
      ),

    [patientEngagementSortTable]: (state, { payload: { field } }) => {
      let order = 'desc';
      if (field === state.sortBy) {
        order = state.order !== 'asc' ? 'asc' : 'desc';
      }

      return mergeLeft(
        {
          sortBy: field,
          order,
        },
        state,
      );
    },
  },
  defaultState,
);
